export const addressFactory = (params: {
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  country: string;
}): string => {
  const streetAddress: string[] = [];
  streetAddress.push(params.street);
  if (params.street) {
    streetAddress.push(params.number);
  }
  const streetAddressString = streetAddress.filter((s) => s).join(", ");

  const cityAddress: string[] = [];
  cityAddress.push(params.district);
  cityAddress.push(params.city);
  const cityAddressString = cityAddress.filter((s) => s).join(", ");

  const stateCountry: string[] = [];
  stateCountry.push(params.state);
  stateCountry.push(params.country);
  const stateCountryString = stateCountry.filter((s) => s).join(", ");

  const datas: string[] = [];
  datas.push(streetAddressString);
  datas.push(cityAddressString);
  datas.push(stateCountryString);

  return datas.filter((s) => s).join(" - ");
};
